import client from "./clients/portalClient";

const getAllDataEntries = (id) => client.get(`/search?q=${id}`);


const elasticSearchApi = {
    getAllDataEntries,
};

export default elasticSearchApi;
